import { ABTestInputCondition, abTestGlobalKey } from '../abtestV2'

export enum SocialProofVariantKey {
  Control = 'control',
  Purchase = 'treatment_purchase', // V1: 128 people bought this week
  Cart = 'treatment_cart', // V2: In 23 carts right now
  Authority = 'treatment_authority', // V3: Best seller in kids drinkware
  Combo = 'treatment_combo', // Step 2 Combo: Purchase + Authority
}

export const PDP_SOCIAL_PROOF_EXPERIMENT_CAMPAIGN: ABTestInputCondition = {
  code: 'pdp_social_proof_campaign',
  exprId: 'pdp_social_proof_experiment',
  exprName: 'PDP Social Proof ATC Experiment',

  startDate: '2026-09-01T00:00:00Z',
  stopDate: '2026-12-31T23:59:59Z',
  endDate: '2026-12-31T23:59:59Z',

  endIfPurchased: false,

  trafficRate: 1,
  variants: [
    { code: SocialProofVariantKey.Control, rate: 0 },
    { code: SocialProofVariantKey.Purchase, rate: 0 },
    { code: SocialProofVariantKey.Combo, rate: 1 },
  ],

  allowedDevices: [],
  allowedCountries: [],
  allowedStores: [],
  allowedUrls: [
    'custom-any-photo-personalized-kid-custom-shaped-acrylic-plaque-10589270226scl1tmn1tr04ha07an01hsp1_ipatukid00476',
    'dad-level-unlocked-funny-gaming-father-t-shirt-and-hoodie-01092021025clo2cle1mt01ds01id01tsh1fth5012a-1',
    'custom-any-photo-forever-missed-personalized-memorial-acrylic-led-night-light-10189060326scl1cle1tu08ha07ha12anl1_ipatudth00261',
    'custom-any-photo-personalized-birthday-custom-shaped-acrylic-plaque-10277270226scl1cle1ph08ph01an01hsp1_ipatubid00013',
    'youve-got-a-friend-in-me-personalized-autism-awareness-blanket-10692180626scl1tmn1tr04th07th12blk1_ipatuats00245',
    'custom-any-photo-personalized-blue-dog-custom-shaped-acrylic-plaque-10416260226scl1tmm1tr04ha07an01hsp1_ipatubly00043',
    'custom-any-photo-perfect-birthday-gift-personalized-birthday-custom-shaped-acrylic-plaque-10683250226scl1cle1ph08ha07ha12hsp1_ipatubid00005',
    'funny-mouse-wash-dishes-personalized-mouse-dishwasher-cover-10922140726scl1tmn1tr04nh02li09dwc1_ipatudsn22663',
    'you-me-we-got-this-personalized-couple-tumbler-10431250726scl1cle1tr04cu03du10tbl1_ipatucpl01231',
    'custom-any-photo-birthmonth-flower-personalized-self-love-bookshelf-lamp-10673110826scl1cle1ph08nh02tr15bsl1_ipatuslv00141',
    'custom-from-any-photo-personalized-mother-custom-shaped-acrylic-plaque-10127120226scl1cle1tr04ha07my04hsp1_ipatumth00632',
    'the-little-racer-personalized-racing-lover-premium-faux-fur-pillow-10726160726scl1tmn1tr04ha07li09fsp2_ipatucsm00009',
    'custom-any-photo-you-me-personalized-couple-acrylic-led-night-light-10108160126scl1cle1tr04nh02ha12anl1_ipatucpl00928',
    'laundry-today-personalized-mouse-storage-basket-10436150626scl1tmn1tr04ha08an01lbk1_ipatudsn22485',
    'custom-photo-alphabet-any-theme-personalized-kid-changeable-leather-patch-backpack-10359100726scl1cle1tr04nh02tr15sbp1_ipatukid00813',
    'the-little-racer-personalized-racing-lover-acrylic-display-box-10944280726scl1tmn1tr04cu03tr15acd1_ipatucsm00020',
    'your-wings-were-ready-personalized-memorial-wooden-floating-shelf-10108230626scl1cle1tu08nh02du10wfs1_ipatudth00356',
    'custom-any-photo-birthday-gift-personalized-birthday-custom-shaped-acrylic-plaque-10625240326scl1cle1ph08nh02ha12hsp1_ipatubid00024',
    'autism-support-cartoon-puzzle-toy-personalized-autism-awareness-custom-shaped-acrylic-plaque-10871110326scl1tmn1tr04nh02tr18hsp1_ipatuats00192',
    'believe-in-magic-personalized-dream-trip-satin-robe-10414040826scl1tmn1tr04th07an01srb1_ipatudnl00105',
    'custom-from-any-photo-personalized-hunting-3d-printed-cut-metal-sign-10271290926scl1cle1tr04nh02li09dcm1_ipatuhut00558',
    'we-are-never-too-old-mouse-cross-tank-top-2-16072021902scl1tmn1ch02me01th01ctt1dsn6420upsalea',
    'bathing-time-personalized-mouse-quick-dry-beach-towel-bath-towel-10154060826scl1tmn1tr04ha09du10btw1_ipatudsn22845',
    'funny-nurse-relax-toy-personalized-nurse-posable-plush-doll-10390170926scl1cle1tr04cu03ha13pld1_ipatunur00302',
    'custom-from-any-photo-personalized-memorial-faux-fur-shaped-pillow-10101130126scl1cle1tu08cu03my04fsp1_ipatudth00179',
    'custom-from-any-photo-personalized-football-acrylic-display-box-10164110926scl1cle1tu08cu03li09acd1_ipatuftb00131',
    'love-you-infinite-bedroom-decoration-personalized-couple-cut-metal-sign-10148071026scl1cle1tr04cu03li09cms1_ipatucpl01512',
    'magical-christmas-personalized-mouse-led-light-tree-topper-10116281125scl1tmn1tr04ph01th12ltp1_ipatudsn21629',
    'custom-any-photo-perfect-office-decoration-personalized-colleague-custom-shaped-acrylic-plaque-10401230226scl1cle1ph08cu03ha12hsp1_ipatuclg00029',
    'any-photo-nurse-life-personalized-nurse-cardigan-sweater-10511130826scl1cle1tr04cu03ha12cas1_ipatunur00264',
    'alphabet-initial-for-whiskey-bourbon-lovers-personalized-whisky-whiskey-glass-10623310726scl1cle1ph08cu03tr15wkg1_ipatuwsk00186',
    'naughty-spooky-couple-personalized-nightmare-tumbler-10705140826scl1tmn1ph08th07tr18tbl1_ipatujak00828',
    'gift-for-her-flower-bouquet-and-number-personalized-birthday-custom-shaped-acrylic-plaque-10595120226scl1cle1ph08th07tr15hsp1_ipatubid00003',
    'zodiac-sign-luxury-rope-personalized-horoscope-satin-robe-10833240726scl1cle1ph08ha09li09srb1_ipatuhrs00019',
    'happy-anniversary-i-love-you-personalized-couple-custom-shaped-acrylic-plaque-10309100426scl1cle1tr04ph01tr15hsp1_ipatucpl01071',
    'may-the-force-be-with-you-personalized-the-force-blanket-10159080826scl1tmn1tr04ha07du10blk1_ipatustw00532',
    'custom-any-photo-personalized-birthday-custom-shaped-acrylic-plaque-10463070426scl1cle1ph08nh02ha12hsp1_ipatubid00039',
    'believe-in-magic-personalized-mouse-open-toe-slippers-10577180826scl1tmn1tr04nh02an01tsl1_ipatudsn22945',
    'im-yours-no-return-of-refunds-personalized-couple-wooden-floating-shelf-10463060826scl1cle1tr04nh02du10wfs1_ipatucpl01249',
    'may-the-force-be-with-you-personalized-the-force-beer-stein-10460110326scl1tmn1tr04ha09du10brs1_ipatustw00386',
    'custom-real-3d-figure-from-any-photo-personalized-fishing-premium-3d-figurine-10391200326scl1cle1tu08ph01li09pfg1_ipatufsh00244',
    'magical-castle-personalized-mouse-hoodie-and-leggings-10518300725scl1tmn1tr04cu03an01s002_ipatudsn21020',
    'nurse-life-personalized-nurse-clogs-with-arch-support-10368270826scl1cle1tr04cu03an01cls1_ipatunur00270',
    'any-sport-volleyball-football-basketball-baseball-personalized-volleyball-custom-shaped-acrylic-plaque-10511260126scl1cle1tu08nh02tr15hsp1_ipatuvlb00004',
    'love-god-play-baseball-personalized-baseball-shaped-metal-pendant-necklace-10948270826scl1cle1tu08ha09li09smp1_ipatubsb00114',
    '33rd-anniversary-personalized-nightmare-tumbler-with-plush-charm-10308210526scl1tmn1ph08ha09du10twh1_ipatujak00680',
    'hello-darkness-personalized-nightmare-tote-bag-10717050526scl1tmn1ph08cu03an01tot1_ipatujak00671',
    'breast-cancer-awareness-personalized-breast-cancer-awareness-premium-keychain-with-charms-10957080826scl1tmn1ph08ha07an01kwc2_ipatubrc00224',
    'fairy-tale-romantic-tale-as-old-as-time-personalized-beauty-and-the-beast-wine-glasses-set-with-wooden-box-10216030826scl1tmn1ph08ha07tr15wgb1_ipatubtb00142',
    'magic-friends-personalized-mouse-kid-hoodie-kid-jogger-sweatpants-10333250826scl1tmn1tr04th07th12s033_ipatudsn23008',
    'blue-ohana-personalized-ohana-varsity-jacket-10490081025scl1tmn1tr04nh02ha12vjk1_ipatusth00487',
    'magical-friends-personalized-mouse-varsity-jacket-10165120826scl1tmn1tr04ha09tr15vjk1_ipatudsn22901',
    'whiskey-cigar-personalized-whisky-led-light-acrylic-sign-10422070426scl1cle1ph08ha07li09lla1_ipatuwsk00144',
    'custom-from-any-photo-personalized-family-custom-shaped-acrylic-plaque-10386251225scl1cle1tr04ha09ha12hsp1_ipatufml00349',
    'cannabis-stash-jar-personalized-weed-cookie-jar-10164130626scl1ris1ph08ha09li09ckj1_ipatuwed00322',
    'custom-any-photo-personalized-monster-trainer-custom-shaped-acrylic-plaque-10575040326scl1tmm1ph08nh02an01hsp1_ipatupkm00052',
    'any-photo-monogram-ashtray-personalized-real-men-wood-tray-10792180826scl1cle1ph08cu03tr15wtr1_ipatumne00014',
    'photo-balloons-and-number-personalized-birthday-custom-shaped-acrylic-plaque-10530110326scl1cle1ph08ha07tr15hsp1_ipatubid00021',
    'i-am-yours-personalized-stole-christmas-quilt-set-10829011125scl1tmm1tr04cu02an01qbs1_ipatugrc00278',
    'family-trip-any-photo-personalized-mouse-ornament-11380924001scl1tmn1tr04ha08ha12onm1dsn9589',
    'hooked-on-fishing-personalized-fishing-beanie-hat-10248101125scl1cle1tu08th07tr18bha1_ipatufsh00102',
    'love-fishing-personalized-fishing-shaped-christmas-stocking-10581241025scl1cle1tu08cu03ha12scs1_ipatufsh00092',
    'flower-bouquet-vase-perfect-mothers-day-gift-personalized-kid-acrylic-pot-10207090426scl1cle1tr04ha07my04apt1_ipatukid00618',
    'friends-personalized-mouse-blanket-10499151125scl1tmn1tr04nh02an01blk1_ipatudsn21553',
    'happy-graduation-gift-personalized-graduation-premium-faux-fur-pillow-10905120226scl1cle1ph08cu03ha13fsp2_ipatugrd00037',
    'love-sewing-personalized-sewing-accent-mug-coaster-10830081225scl1cle1tr04ha07an01s072_ipatusew00117',
    'serve-and-protect-personalized-police-officer-whiskey-glass-10427120725scl1cle1ph08cu03li09wkg1_ipatuplc00022',
    'whiskey-and-cigar-personalized-whisky-custom-shaped-acrylic-plaque-10537200326scl1cle1ph08nh02tr15hsp1_ipatuwsk00134',
    'custom-any-photo-personalized-father-custom-shaped-acrylic-plaque-10784070526scl1cle1tr04ha09ha12hsp1_ipatufth00738',
    'live-love-golf-personalized-golf-accent-mug-10887171125scl1cle1tu08ha07an01acm1_ipatugof00110',
    'love-crocheting-personalized-crocheting-accent-mug-10293041225scl1cle1tr04ha07an01s072_ipatucrc00012',
    'duck-hunting-season-personalized-hunting-beanie-hat-10603271125scl1cle1tr04cu03du10bha1_ipatuhut00293',
    'custom-any-photo-magical-princess-friends-personalized-princesses-custom-shaped-acrylic-plaque-10443150126scl1tmn1tr04nh02ha12hsp1_ipatudsn21972',
    'friends-personalized-mouse-accent-mug-10331211125scl1tmn1tr04nh02ha12acm1_ipatudsn21579',
    'love-hunting-personalized-hunting-blanket-10807281025scl1cle1tr04ha09an01blk1_ipatuhut00206',
    'funny-gift-cartoonish-exaggerated-mascot-style-personalized-bestie-custom-shaped-acrylic-plaque-10765291025scl1cle1ph08ha07tr15hsp1_ipatubet00095',
    'hairdresser-with-scissors-salon-decor-personalized-hairdresser-custom-shaped-acrylic-plaque-10680050226scl1cle1ph08th07tr15hsp1_ipatuhdr00017',
    'custom-any-title-gift-for-teacher-educator-personalized-teacher-custom-shaped-acrylic-plaque-10108100326scl1cle1tr04nh02ha12hsp1_ipatutch00065',
    'i-licked-it-so-its-mine-personalized-nightmare-custom-shaped-acrylic-plaque-10950081225scl1tmn1ph08nh02tr18hsp1_ipatujak00516',
    'farm-life-personalized-highland-cow-beanie-hat-10596051225scl1cle1tr04cu03tr18bha1_ipatuhlc00236',
    'custom-from-any-photo-personalized-hunting-custom-shaped-hanging-rack-10388111225scl1cle1tr04th07ha12ckr1_ipatuhut00358',
    'love-sewing-personalized-sewing-accent-mug-10608271125scl1cle1tr04ha07an01acm1_ipatusew00100',
    'custom-any-photo-love-my-pet-personalized-dog-acrylic-pot-10809120226scl1cle1tu08cu03du10apt1_ipatudog00690',
    'the-galaxy-personalized-the-force-accent-mug-10185111125scl1tmn1tr04ha07an01acm1_ipatustw00260',
    'funny-gift-cartoonish-exaggerated-mascot-style-personalized-family-custom-shaped-acrylic-plaque-10177221025scl1cle1tr04ha08tr15hsp1_ipatufml00282',
    'ohana-means-family-personalized-ohana-blanket-hoodie-22281223001scl1tmm1th06ma01th12blh1sth5972',
    'magical-friends-and-christmas-ornament-gift-personalized-mouse-shaped-pillow-10335170925scl1tmn1tr04ha08tr15spl1_ipatudsn21137',
    'custom-any-photo-perfect-gift-for-mom-grandma-personalized-mother-custom-shaped-acrylic-plaque-10111020226scl1cle1tr04cu03ha12hsp1_ipatumth00591',
    'merry-chrisrtmas-personalized-stole-christmas-accent-mug-29082023901scl1tmm1th06hu09an01acm1grc5348',
    'you-and-me-we-got-this-red-rose-bouquet-personalized-mouse-faux-fur-shaped-pillow-10923130126scl1tmn1tr04ha07my01fsp1_ipatudsn21913',
    'i-love-you-to-the-moon-and-back-personalized-couple-custom-shaped-acrylic-plaque-10239241125scl1cle1tr04ph01ha12hsp1_ipatucpl00676',
    'ohana-means-family-personalized-ohana-custom-shaped-acrylic-plaque-10328270126scl1tmn1tr04nh02an01hsp1_ipatusth00674',
    'any-title-any-photo-personalized-nurse-tumbler-10100210326scl1cle1tr04nh02tr15tbl1_ipatunur00174',
    'im-yours-no-returns-or-refunds-personalized-ohana-faux-fur-shaped-pillow-10128251225scl1tmn1tr04ph01th12fsp1_ipatusth00612',
    'custom-photo-mothers-day-perfect-gift-personalized-mother-custom-shaped-acrylic-plaque-10834110426scl1cle1tr04th07du10hsp1_ipatumth00823',
    'custom-any-photo-birthmonth-flower-personalized-self-love-custom-shaped-acrylic-plaque-10996020226scl1cle1ph08ha07an01hsp1_ipatuslv00008',
    'custom-from-any-photo-you-and-me-we-got-this-personalized-couple-custom-shaped-acrylic-plaque-10257301225scl1cle1tr04li10my04hsp1_ipatucpl00849',
    'bid00013',
    'dnl00105',
    'hut00558',
    'bly00043',
    'kid00476',
    'dsn22845',
    'nur00302',
    'bid00005',
    'dth00179',
    'ftb00131',
    'cpl01512',
    'dsn21629',
    'clg00029',
    'dth00261',
    'nur00264',
    'wsk00186',
    'jak00828',
    'bid00003',
    'hrs00019',
    'cpl01071',
    'mth00632',
    'stw00532',
    'bid00039',
    'dsn22945',
    'bid00024',
    'cpl01249',
    'stw00386',
    'fsh00244',
    'dsn21020',
    'nur00270',
    'vlb00004',
    'bsb00114',
    'jak00680',
    'kid00813',
    'jak00671',
    'brc00224',
    'btb00142',
    'dsn23008',
    'cpl01231',
    'sth00487',
    'dsn22901',
    'dth00356',
    'wsk00144',
    'fml00349',
    'wed00322',
    'pkm00052',
    'mne00014',
    'bid00021',
    'grc00278',
    'dsn9589',
    'fsh00102',
    'fsh00092',
    'kid00618',
    'dsn21553',
    'grd00037',
    'sew00117',
    'plc00022',
    'wsk00134',
    'fth00738',
    'gof00110',
    'crc00012',
    'hut00293',
    'dsn21972',
    'dsn21579',
    'hut00206',
    'bet00095',
    'hdr00017',
    'tch00065',
    'jak00516',
    'cpl00928',
    'hlc00236',
    'hut00358',
    'sew00100',
    'dog00690',
    'stw00260',
    'fml00282',
    'sth5972',
    'dsn21137',
    'mth00591',
    'grc5348',
    'dsn21913',
    'cpl00676',
    'sth00674',
    'nur00174',
    'sth00612',
    'mth00823',
    'slv00008',
    'cpl00849',
    'dsn22693',
    'jak6229',
    'dsn20956',
    'dsn22801',
    'dsn21072',
    'dsn20968',
    'poh00185',
    'dsn22814',
    'jak2402',
    'dsn22775',
    'dsn22727',
    'jak00172',
    'jak00856',
    'dsn22723',
    'jep5810',
    'dsn22681',
    'jak00905',
    'dsn20808',
    'jak00848',
    'dnl00119',
    'dsn8157',
    'ctt6096',
    'jak6697',
    'dsn22748',
    'jak00813',
    'jak00764',
    'dsn22850',
    'jak00841',
    'dsn2469',
    'dsn5891',
    'dsn22875',
    'dsn2471',
    'dsn22880',
    'dsn22894',
    'dsn23013',
    'dsn22581',
    'dsn22767',
    'sth00945',
    'poh00211',
    'dsn22916',
    'dsn22985',
    'jak00805',
    'dsn23023',
    'dsn22834',
    'jak00766',
    'dsn22858',
    'dsn22700',
    'bet5117',
    'sth00992',
    'dsn23004',
    'dsn22965',
    'dsn22806',
    'jak00783',
    'dnl00103',
    'dsn22687',
    'dsn22785',
    'jak00842',
    'dsn22810',
    'sth00955',
    'poh00176',
    'dsn22874',
    'sth00963',
    'dog01275',
    'dog01292',
    'dog01305',
    'wic00613',
    'dog01296',
    'kid00869',
    'dog01269',
    'kid00945',
    'fml00442',
    'wic00588',
    'skl00419',
    'kid00938',
    'tcr00026',
    'kid00902',
    'dog01356',
    'bak00188',
    'wic00577',
    'crl00071',
    'wic00603',
    'dog01276',
    'dog01383',
    'bet00215',
    'dog01372',
    'kid00965',
    'cpl01241',
    'wic00098',
    'dog01360',
    'kid00787',
    'grm00430',
    'grm00431',
    'kid00886',
    'hlw2084',
    'wic2668',
    'brc2335',
    'mth7376',
    'wic2426',
  ],
}
